var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11538 5.57479C5.96838 5.58229 5.82638 5.61529 5.69438 5.68729C5.47988 5.80379 5.32788 6.00629 5.18788 6.20579C3.75838 8.24729 2.88088 10.6713 2.67238 13.1548C2.62838 13.6818 2.62188 14.2453 2.89388 14.6983C3.21638 15.2353 3.85038 15.4903 4.45088 15.6708C7.06838 16.4588 9.84038 16.5073 12.5654 16.7253C16.2149 17.0173 19.8959 17.6228 23.5134 17.0593C24.6254 16.8863 25.7344 16.5978 26.7144 16.0438C29.2979 14.5843 29.8584 11.6173 28.7044 9.01079C28.1614 7.78479 27.3079 6.67679 26.1789 5.95279C24.4614 4.85179 22.2829 4.73179 20.2609 5.00779C18.2394 5.28379 16.2799 5.91679 14.2599 6.20279C11.8449 6.54479 9.35988 6.38129 7.01038 5.72579C6.72088 5.64529 6.40888 5.55929 6.11538 5.57479Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47123 24.7782C5.324 24.7794 5.18179 24.7847 5.04959 24.7963C4.83476 24.8151 4.68253 24.8477 4.54232 24.8799C3.11065 25.2089 2.23182 25.5996 2.023 25.9999C1.97894 26.0848 1.97243 26.1756 2.24484 26.2487C2.56783 26.3352 3.20279 26.3763 3.8042 26.4054C6.42567 26.5324 9.20188 26.5402 11.931 26.5753C15.5861 26.6224 19.2726 26.72 22.8956 26.6292C24.0093 26.6013 25.12 26.5548 26.1015 26.4655C28.6889 26.2303 29.2503 25.7521 28.0945 25.332C27.5507 25.1344 26.6959 24.9558 25.5652 24.8391C23.8451 24.6617 21.6633 24.6423 19.6382 24.6868C17.6136 24.7313 15.6512 24.8333 13.6281 24.8794C11.2094 24.9345 8.72065 24.9082 6.36759 24.8025C6.07765 24.7896 5.76517 24.7757 5.47123 24.7782Z",
    fill: "#F4F4F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03906 16.2355C3.09406 13.356 3.03906 7.6465 3.25806 4.774V4.6645C10.7756 4.896 20.7271 4.628 28.2446 4.5C28.2446 7.373 28.2691 13.0705 28.4211 15.931C20.7696 16.406 10.6841 17.082 3.03906 16.2355Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2447 7.6084C14.2447 7.6929 14.9197 12.8969 13.1477 13.2349C11.3757 13.5729 11.6332 11.5374 11.9122 10.7824",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7893 9.60587C17.7893 9.60587 19.0068 12.3579 17.1883 12.0229C15.3698 11.6879 15.9043 7.69287 15.9043 7.69287",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6025 8.49708C25.4505 8.72659 25.203 8.90909 24.9425 8.95709C24.602 9.01959 24.2325 8.88809 24.008 8.62459C23.7595 8.33309 23.719 7.84909 23.991 7.57958C24.15 7.42208 24.3805 7.36059 24.603 7.33609C24.9045 7.30308 25.23 7.33208 25.4755 7.51058C25.841 7.77658 25.812 8.18108 25.6025 8.49708Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1319 13.6815C17.1169 13.8406 17.0506 13.99 16.9388 14.0728C16.7983 14.1792 16.5895 14.1857 16.4201 14.0875C16.2295 13.9771 16.0881 13.714 16.1537 13.5105C16.1849 13.3877 16.2837 13.3108 16.3801 13.2458C16.5091 13.1663 16.6739 13.1142 16.8295 13.1641C17.0642 13.2331 17.1527 13.4655 17.1319 13.6815Z",
    fill: "#393B46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.755 13.3485C18.74 13.5076 18.6737 13.657 18.5618 13.7398C18.4214 13.8462 18.2126 13.8527 18.0432 13.7545C17.8526 13.6441 17.7112 13.381 17.7768 13.1775C17.808 13.0547 17.9068 12.9778 18.0031 12.9128C18.1321 12.8333 18.2969 12.7812 18.4526 12.8311C18.6873 12.9001 18.7757 13.1325 18.755 13.3485Z",
    fill: "#393B46"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30834 7.5208C7.19534 7.7368 6.99884 7.9218 6.77334 8.0063C6.50884 8.1053 6.20184 8.0848 5.95284 7.9508C5.75734 7.8458 5.59684 7.6693 5.52934 7.4578C5.46134 7.2463 5.49284 7.0013 5.62734 6.8248C5.75584 6.6563 5.96084 6.5633 6.16534 6.5083C6.47535 6.4253 6.82534 6.4213 7.09634 6.5923C7.46084 6.8213 7.47434 7.2043 7.30834 7.5208Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40088 19.662C3.40088 19.662 20.3334 20.8345 27.6969 19.3335",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21338 23.4681C3.21338 23.4681 22.3499 24.5936 27.6504 22.7646",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1665 26.8521C3.1665 26.8521 18.1755 28.9626 27.6505 26.4771",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1678 11.3501C19.1678 11.3501 21.2213 13.8821 18.0708 14.8666",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoney);
export default __webpack_public_path__ + "static/media/icon-money.78a0597e0b086047b4e824ee5aeed9d9.svg";
export { ForwardRef as ReactComponent };